/**
 * "Recently viewed" band (sections/recently-viewed.liquid). The list is kept in localStorage per storefront language:
 * a product page adds its own product (data-current) to the front; every page shows the list minus the current
 * product, and stays hidden until two products are left to show.
 */
const LIMIT = 16;

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const key = `echovira:recently-viewed:${this.dataset.locale || 'en'}`;
    let list = read(key);
    let current = null;
    try {
      current = this.dataset.current ? JSON.parse(this.dataset.current) : null;
    } catch (error) {
      console.error('recently-viewed: the current product data is not valid JSON, so this product is not recorded', error);
    }
    if (current?.id) {
      list = [{ ...current, at: Date.now() }, ...list.filter((item) => item.id !== current.id)].slice(0, LIMIT);
      write(key, list);
    }
    const max = Number(this.dataset.max) || 12;
    const shown = list.filter((item) => item.id !== current?.id && item.url && item.image).slice(0, max);
    if (shown.length < 2) return;

    const ul = this.querySelector('.recently-viewed__list');
    if (!ul) return;
    ul.replaceChildren(...shown.map(card));
    this.hidden = false;
  }
}

function card(item) {
  const li = document.createElement('li');
  li.className = 'recently-viewed__item';
  const a = document.createElement('a');
  a.className = 'recently-viewed__card';
  a.href = item.url;
  const media = document.createElement('div');
  media.className = 'recently-viewed__media';
  const img = document.createElement('img');
  img.src = item.image;
  img.alt = item.title || '';
  img.loading = 'lazy';
  img.decoding = 'async';
  img.width = 480;
  img.height = 480;
  media.append(img);
  const title = document.createElement('span');
  title.className = 'recently-viewed__title';
  title.textContent = item.title || '';
  const price = document.createElement('span');
  price.className = 'recently-viewed__price';
  price.textContent = item.price || '';
  if (item.compare) {
    const was = document.createElement('s');
    was.textContent = item.compare;
    price.append(was);
  }
  a.append(media, title, price);
  li.append(a);
  return li;
}

function read(key) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(value) ? value : [];
  } catch (error) {
    console.error(`recently-viewed: cannot read "${key}" from localStorage, showing nothing`, error);
    return [];
  }
}

function write(key, list) {
  try {
    localStorage.setItem(key, JSON.stringify(list));
  } catch (error) {
    console.error(`recently-viewed: cannot save "${key}" to localStorage (blocked or full), the band will not remember`, error);
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed);
}
